import React from 'react';
import DateTime from '~domain/model/core/date/datetime';
import { PolicySummaryFacade } from '~domain/model/facade/policy/policy-summary-facade';
import { Grid, GridProps } from '~ui-kit/components/grid';
import { PolicyCard } from '../policy-card';

interface PolicyCardsGridProps extends GridProps {
  policies: PolicySummaryFacade[];
  images: any;
  onModifyPolicy?: (policy: PolicySummaryFacade) => void;
  onDocumentsClicked?: (policy: PolicySummaryFacade, event: React.KeyboardEvent | React.MouseEvent) => void;
}

export function PolicyCardsGrid({
  policies,
  images,
  onModifyPolicy,
  onDocumentsClicked,
  ...gridProps
}: PolicyCardsGridProps) {
  function isFutureRenewal(policy: PolicySummaryFacade, policies: PolicySummaryFacade[]): boolean {
    const isFuture = policy.effectiveDate.isDateGreaterThanOrEqual(new DateTime());

    // we need to check every policy for duplicate policy number because we can't trust the 'renewal' status
    // exclude the policy being checked, then compare policy numbers (should be the same for renewal)
    const otherPolicies = policies.filter((p) => p.id !== policy.id);
    const hasDupePolicyNumber = otherPolicies.some((p) => p.policyNumber === policy.policyNumber);

    return hasDupePolicyNumber && isFuture;
  }

  return (
    <Grid $gridTemplateColumns={['auto', 'repeat(2, 1fr)']} $gridGap={3} $mt={[4, 4, '48px']} {...gridProps}>
      {policies.map((policy) => (
        <PolicyCard
          key={policy.id}
          policy={policy}
          renewal={isFutureRenewal(policy, policies)}
          onModifyPolicy={onModifyPolicy}
          onDocumentsClicked={onDocumentsClicked}
        />
      ))}
    </Grid>
  );
}
